/**
 * Internationalization (i18n) Setup
 * Simple i18n implementation without external dependencies
 */

import th from './th';
import en from './en';

const locales = {
  th,
  en,
};

// Default locale
let currentLocale = 'th';

/**
 * Set current locale
 * @param {string} locale - 'th' or 'en'
 */
export const setLocale = (locale) => {
  if (locales[locale]) {
    currentLocale = locale;
  } else {
    console.warn(`Locale '${locale}' not found. Using default 'th'.`);
  }
};

/**
 * Get current locale
 * @returns {string}
 */
export const getLocale = () => currentLocale;

/**
 * Get translation by key path
 * @param {string} key - dot notation path (e.g., 'uploadHistory.title')
 * @param {Object} params - optional parameters for interpolation
 * @returns {string}
 */
export const t = (key, params = {}) => {
  const keys = key.split('.');
  let value = locales[currentLocale];

  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      console.warn(`Translation key '${key}' not found in locale '${currentLocale}'`);
      return key;
    }
  }

  // Simple parameter interpolation
  if (typeof value === 'string' && Object.keys(params).length > 0) {
    return value.replace(/\{(\w+)\}/g, (match, param) => {
      return params[param] !== undefined ? params[param] : match;
    });
  }

  return value || key;
};

/**
 * Composable for use in Vue components
 */
export const useI18n = () => {
  return {
    t,
    locale: currentLocale,
    setLocale,
    getLocale,
  };
};

export default {
  setLocale,
  getLocale,
  t,
  useI18n,
};
